import { render, staticRenderFns } from "./CompanyTradieAccessList.vue?vue&type=template&id=ecff52e4&scoped=true"
import script from "./CompanyTradieAccessList.vue?vue&type=script&lang=js"
export * from "./CompanyTradieAccessList.vue?vue&type=script&lang=js"
import style0 from "./CompanyTradieAccessList.vue?vue&type=style&index=0&id=ecff52e4&prod&lang=css"
import style1 from "./CompanyTradieAccessList.vue?vue&type=style&index=1&id=ecff52e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecff52e4",
  null
  
)

export default component.exports